import * as React from 'react';
import { useSelector } from 'react-redux';

import { AboutCompany } from '../../components/AboutCompany';
import { selectBuilderDescription, selectFactoids } from '../../selectors/builder';
import { CollapsedTextContainer } from '../CollapsedTextContainer';
import { Description } from '../../components/Description';

export const AboutCompanyContainer = () => {
  const { description, constructionZone, materials } = useSelector(selectBuilderDescription);
  const factoids = useSelector(selectFactoids);

  return (
    <AboutCompany
      description={
        <CollapsedTextContainer
          collapsedHeight={154}
          text={<Description html={description} />}
          button={{ expandText: 'Читать дальше', collapseText: 'Свернуть' }}
        />
      }
      constructionZone={constructionZone}
      materials={materials}
      factoids={factoids}
    />
  );
};
